.nav {
  display: flex;
  flex: none;
  flex-direction: column;
  width: var(--nav-width);
  color: var(--text-on-nav);
  background: var(--bg-nav);
}

.brand {
  flex: none;
  padding: 14px var(--space-4) var(--space-3);
  border-bottom: 1px solid var(--nav-divider);
}

.brandName {
  font-size: 17px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-on-nav-active);
}

/* Название салона всегда видно (ТЗ §4.6), но оно бывает длинным: «Барбершоп на Ленина,
   второй этаж». Обрезается подпись, а не ломается каркас; полное имя — в подсказке. */
.brandTenant {
  margin-top: 2px;
  overflow: hidden;
  font-size: var(--font-size-xs);
  letter-spacing: 0.12em;
  color: var(--nav-accent);
  text-transform: uppercase;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.list {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 1px;
  min-height: 0;
  padding: var(--space-2);
  overflow-y: auto;
}

.item {
  display: flex;
  flex: none;
  gap: var(--space-2);
  align-items: center;
  padding: 7px 10px;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  color: var(--text-on-nav);
  text-decoration: none;
  border-radius: var(--radius-md);
}

.item:hover {
  color: var(--text-on-nav-active);
  background: var(--bg-nav-hover);
}

/*
 * Активный пункт отмечен ТРЕМЯ способами сразу: заливка, яркость текста и полоса слева.
 * Одной заливки мало — в градациях серого и при слабом контрасте экрана она пропадает,
 * а вместе с ней пропадает единственный ответ на вопрос «где я нахожусь».
 */
.itemActive {
  color: var(--text-on-nav-active);
  background: var(--bg-nav-active);
  box-shadow: inset 3px 0 0 var(--nav-accent);
}

.itemLabel {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.dot {
  flex: none;
  width: 6px;
  height: 6px;
  background: var(--nav-accent);
  border-radius: 50%;
}
